import NextIcon from 'assets/icons/next.svg';
import moment from 'moment';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { TooltipText } from 'presentation/components/TooltipText';
import { COMMON } from 'utilities/constants/COMMON';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { DataListProperty } from '../models/Model_CU-029-01';

interface props {
    data: DataListProperty;
    onClickViewDetail: (value: number) => void;
}

export const CardComponent = ({ data, onClickViewDetail }: props) => {
    const getAddressText = (data: DataListProperty) => {
        const result = data?.residence ?? '';
        return result.trim() === '' ? COMMON.EMPTY : result;
    };

    const getNearestStationText = (data: DataListProperty) => {
        const result = data?.finalStationName ?? '';
        return result.trim() === '' ? COMMON.EMPTY : result;
    };
    return (
        <section
            className="card-element button-style glow-on-hover"
            onClick={() => onClickViewDetail(data.id)}
        >
            <div style={{ width: '100%', height: 143, marginBottom: 24 }}>
                <ImageComponent
                    alt=""
                    width={231}
                    height={143}
                    src={data.propertyImages}
                />
            </div>
            <section
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
                <div style={{ textAlign: 'left' }}>
                    <div className="title" style={{ marginBottom: 9, width: '195px' }}>
                        <TooltipText content={data.propertyName ?? COMMON.EMPTY} maxLine={2} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        <div className="label" style={{ width: 40, marginRight: 8 }}>
                            住所
                        </div>
                        <div className="content" style={{ width: '185px' }}>
                            <TooltipText content={getAddressText(data)} maxLine={2} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        <div className="label" style={{ width: 40, marginRight: 8 }}>
                            最寄駅
                        </div>
                        <div className="content" style={{ width: '195px' }}>
                            <TooltipText content={getNearestStationText(data)} maxLine={2} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="label" style={{ width: 40, marginRight: 8 }}>
                            築年月
                        </div>
                        <div className="content">
                            {moment(data.builtAt, true).isValid()
                                ? moment(data.builtAt).format(DATE_FORMAT.FORMAT3)
                                : COMMON.EMPTY}
                        </div>
                    </div>
                </div>
                <div className="button-style">
                    <img alt="" src={NextIcon} />
                </div>
            </section>
        </section>
    );
};
